.tabButton {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  border-radius: 0;
  text-transform: none;
  background-color: transparent;
  line-height: 1.2;
  border: none;
  justify-content: center;
}

.closeButton {
  margin-left: 8px;
}
